import React from 'react'
import { useAppSelector } from 'src/app/hooks'
import { getFormatedPrice } from 'src/core/helpers'
import { currencyListSelector } from 'src/features'
import { MyIntegrationsType } from 'src/core/models'
import { MyIntegrationActionColumn, FormLabels } from 'src/components'

const UserIntegrationMovileViewColumn: React.FC<{ integration: MyIntegrationsType }> = ({ integration }) => {
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c?.symbol === integration.currency_symbol)?.code

  const price = getFormatedPrice(integration.purchase_amount, currencyCode)
  const tons = `${integration.compensated_amount?.toFixed(2)} tCO₂`
  const thirdLabel = `${price} - ${tons}`

  return <>
    <FormLabels
      title={integration.intergation_initial}
      subtitle={integration.integration_code}
      thirdLabel={thirdLabel}
    />

    <div className='centered'>
      <MyIntegrationActionColumn intergation_id={integration.integration_id} />
    </div>
  </>
}

export default UserIntegrationMovileViewColumn
